export default __webpack_public_path__ + "static/media/image-pose-detection.7e177fc9.png";